export const MEDIA_BASE_URL = process.env.MEDIA_BASE_URL;
